import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { HeadingLabel } from '@/scopes/products/pages/components/HeadingLabel'
import { space } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'
import { CountryInfo } from './CountryInfo'
import { FlightInfo } from './FlightInfo'
import { GoodToKnow } from './GoodToKnow'
import { Mealplans } from './Mealplans'
import { SustainabilityCertificateInfo } from './SustainabilityCertificateInfo'

const Wrapper = styled.div``

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space('primitives_space_8')};
`

export default function PracticalInformation() {
  const data = useCMSPageField('PDP.PracticalInformation')
  const hasSustainabilityCertificate = useCMSPageField('PDP.hasSustainabilityCertificate')
  const intl = useIntl()
  const sustainabilityCertificateInfoTitle = intl.formatMessage({ id: 'accommodation_page_sustainability_certificate_title' })

  return (
    <Wrapper>
      <HeadingLabel text={intl.formatMessage({ id: 'practical_info_label' })} />
      <Content>
        {data?.goodToKnowTitle && <GoodToKnow title={data.goodToKnowTitle} />}
        {data?.mealplansTitle && <Mealplans title={data.mealplansTitle} />}
        {data?.flightInformation && <FlightInfo {...data.flightInformation} />}
        {hasSustainabilityCertificate && <SustainabilityCertificateInfo title={sustainabilityCertificateInfoTitle} />}
        {data?.countryInformation && <CountryInfo {...data.countryInformation} />}
      </Content>
    </Wrapper>
  )
}
